import { Select as BaseSelect } from '@base-ui/react';

import { SelectButton } from './SelectButton';
import { SelectGroupLabel } from './SelectGroupLabel';
import { SelectItem } from './SelectItem';
import { SelectList } from './SelectList';
import { SelectRoot } from './SelectRoot';

export const Select = {
  Root: SelectRoot,
  Button: SelectButton,
  List: SelectList,
  Item: SelectItem,
  Group: BaseSelect.Group,
  GroupLabel: SelectGroupLabel,
};
